module.exports = __webpack_public_path__ + "static/media/Gold-Host-Reseller.62e0f5e6.png";